import React, { useState, useEffect, useRef } from 'react';
import './assests/css/style.css';
import imgurl from './assests/images/imgurl';
import Slider from "react-slick";
import { Typography, Button, Link, Box, RadioGroup, Radio } from '@mui/material';
import { useLocation, useNavigate } from "react-router-dom";
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Drawer from '@mui/material/Drawer';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
import AlertComp from './Alert';
import LanguageSelector from './LanguageSelector';
import i18next from "i18next";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import HtmlContentMaster from "../src/utils/HtmlContentMaster";
import { useDispatch, useSelector } from 'react-redux';
import { setgender } from './Reducers/reducer';
import { gTagTracking, serviceDown, trackEvent } from './utils/UtilityFunctions';
import Cookies from 'js-cookie';
import MobileHeader from './components/MobileHeader';
import { postApi } from './api/services';
import MaleIcon from '@mui/icons-material/Male';
import FemaleIcon from '@mui/icons-material/Female';
import ReactPlayer from 'react-player';
import AllOutIcon from '@mui/icons-material/AllOut';
import OpenWithIcon from '@mui/icons-material/OpenWith';
import MainLoader from './components/MainLoader';
import swal from 'sweetalert';

function OnBoardingSlider() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [activeIndex, setActiveIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const [femaleInfoModal, setFemaleInfoModal] = useState(false);
  const [consentchk, setconsentchk] = useState(false);
  const [alertopen, setalertopen] = useState(false);
  const [alertmsg, setalertmsg] = useState("Test");
  const [genderToggle, setGenderToggle] = useState("");
  const [defaultGender, setDefaultGender] = useState(null)
  const [openDialog, setOpenDialog] = useState(false);
  const [privacyDrawer, setPrivacyDrawer] = React.useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [play, setPlay] = useState(true)
  const [isLoading, setIsLoading] = useState(false)

  let sliderRef = useRef(null);

  const { Gender } = useSelector((state) => state.user.profile)

  useEffect(() => {
    if (!window.cordova) {
      let isMobile = /iPhone|iPod|iPad|Android/i.test(navigator.userAgent);
      if (!isMobile) {
        setIsMobile(false);
      } else {
        setIsMobile(true);
      }
    }
  }, []);

  useEffect(() => {
    GAEvent()
  }, [])

  const GAEvent = async () => {
    try {
      await trackEvent('no_signup_visited', 'success', '', localStorage.getItem('phno'))  
      await gTagTracking('no_signup_visited', {
        action: 'success',
        error: '',
        mobile_number: localStorage.getItem('phno')
      })
    } catch (err) {
      console.log("err", err);
      await trackEvent('no_signup_visited', 'fail', err, localStorage.getItem('phno'))  
      await gTagTracking('no_signup_visited', {
        action: 'fail',
        error: err,
        mobile_number: localStorage.getItem('phno')
      })
    }
  }

  // useEffect(() => {
  //   if(location?.state?.from === 'expandVideo'){
  //     setActiveIndex(1)
  //     setGenderToggle(localStorage.getItem('gender'))
  //     next();
  //     location.state.from = null
  //   }
  //   !localStorage.getItem('gender') ? localStorage.setItem('gender', "male") : localStorage.setItem('gender', localStorage.getItem('gender'))
  // }, [])

  const next = async () => {
    try {
      if(!genderToggle || genderToggle == '') {
        swal({
          title: i18next.t("Please select your gender"),
          icon: "warning",
          button: i18next.t("Ok"),
        })
      } else {
        if (activeIndex == 0) {
          // Check if user_obj exists and compare gender
          let userObj = JSON.parse(localStorage.getItem('user_obj'))
          if (userObj && userObj.user_id) {
            // Get selected gender (capitalized for comparison)
            let selectedGender = capitalizeFirstLetter(genderToggle)
            // Get gender from user_obj
            let userObjGender = userObj.gender || ''
            
            // Compare genders (case-insensitive)
            if (selectedGender.toUpperCase() !== userObjGender.toUpperCase()) {
              // Gender doesn't match, update via API
              try {
                setIsLoading(true)
                let params = {
                  user_id: userObj.user_id,
                  gender: selectedGender
                }
                console.log("update_user_gender params", params);
                let res = await postApi('update_user_gender', params)
                console.log("update_user_gender res", res);
                
                if (res && !res.error) {
                  // Update gender in user_obj in localStorage
                  userObj.gender = selectedGender
                  localStorage.setItem('user_obj', JSON.stringify(userObj))
                } else {
                  console.log("Error updating gender:", res?.error);
                }
                setIsLoading(false)
              } catch (err) {
                console.log("err updating gender", err);
                setIsLoading(false)
                serviceDown()
              }
            }
          }
          
          dispatch(setgender(genderToggle))
          localStorage.setItem('gender', genderToggle)
          addUser()
          // navigate("/taketest", { replace: true, state: location?.state?.from ? "needhelp" : "onboardingComplete"})
          // if (consentchk) {
          //   sliderRef.slickNext();
          // } else {
            // setalertmsg("Please agree to our terms and conditions.");
            // setalertopen(true);
            // setTimeout(() => {
            //   setalertopen(false);
            // }, 4000);
          // }
          // sliderRef.slickNext();
        } else if (activeIndex == 1) {
          // await trackEvent('consent_given', 'success', '', localStorage.getItem('phno'))  
          // await gTagTracking('consent_given', {
          //   action: 'success',
          //   error: '',
          //   mobile_number: localStorage.getItem('phno')
          // })
          // dispatch(setgender(genderToggle))
          // localStorage.setItem('gender', genderToggle)
          // navigate("/taketest", { replace: true, state: "onboardingComplete" });
          // if(localStorage.getItem("test_taken")){
          //   navigate('/taketest')
          // } else {
            // navigate('/tutorial')
          // navigate("/taketest", { replace: true, state: location?.state?.from ? "needhelp" : "onboardingComplete"})
          // }
        } else {
          sliderRef.slickNext();
        }
      }
    } catch(err) {
      console.log("err", err);  
    }
  };

  const previous = () => {
    if (activeIndex == 0) {
      // navigate('/loginpage', { replace: true })
    } else {
      sliderRef.slickPrev();
    }
  };

  const settings = {
    // dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipe: false,
    afterChange: (current) => setActiveIndex(current),
  };

  const toggleChckBox = async (e) => {
    try{
      setconsentchk(e.target.checked);
      let genderVal = ''
      // if(defaultGender){
      //   genderVal = defaultGender.toUpperCase() == "MALE" ? "Male" : "Female"
      // } else {
        genderVal = genderToggle.toUpperCase() == "MALE" ? "Male" : "Female"
      // }
      updateTerms(e.target.checked, genderVal)
    } catch (err) {
      console.log("err", err);
      // await trackEvent('consent_given', 'fail', err, localStorage.getItem('phno'))  
    }
  }

  const updateTerms = async (val, genderVal) => {
    try {
      let params = {
        phone_number: localStorage.getItem("phno"),
        termsncondsconsent: val,
        gender: genderVal
      }
      console.log("update_terms_consent params", params);
      let res = await postApi('update_terms_consent', params)
      if(res){
        console.log("update_terms_consent res", res);
      }
    } catch (err) {
      console.log("err", err);
      serviceDown()
    }
  }

  // content
  const male = [
    {
      // title: i18next.t("Show your Hairline"), // English text = key
      description: i18next.t("If you have long hair, pull it back so the edges of where your scalp meets your forehead is clearly visible."),
    },
    {
      // title: i18next.t("Keep your Distance"),
      description: i18next.t("Hold the camera about 20 cm away from your head."),
    },
    {
      // title: i18next.t("Use Proper Lighting"),
      description: i18next.t("Make sure you are in a well-lit area."),
    },
    {
      // title: i18next.t("Remove Eyewear"),
      description: i18next.t("Take off glasses, scarves, bands, or anything that covers your scalp."),
    },
  ];

  const female = [
    {
      // title: i18next.t("Create a Center Part"), // English text = key
      description: i18next.t(
        "Use a comb to part your hair straight down the middle."
      ),
    },
    {
      // title: i18next.t("Keep Your Distance"),
      description: i18next.t(
        "Hold the camera about 20 cm away from your head."
      ),
    },
    {
      // title: i18next.t("Remove Accessories"),
      description: i18next.t(
        "Take off glasses, scarves, bands, or anything that covers your scalp."
      ),
    },
    {
      // title: i18next.t("Avoid Wet or Oily Hair"),
      description: i18next.t(
        "Your hair should be free of oil, gel, mousse, or any styling products that coat your scalp."
      ),
    },
    {
      // title: i18next.t("Use Proper Lighting"),
      description: i18next.t("Make sure you are in a well-lit area."),
    },
  ];

  const guidelines = defaultGender
    ? defaultGender.toUpperCase() == "MALE"
      ? male
      : female
    : genderToggle
    ? genderToggle.toUpperCase() == "MALE"
      ? male
      : female
    : "";

  const handleToggleChange = async (event) => {
    try{
      setGenderToggle(event.target.value);
      dispatch(setgender(event.target.value))
      localStorage.setItem('gender', event.target.value)
      await trackEvent('gender', 'success', '', localStorage.getItem('phno'))  
      await gTagTracking('gender', {
        action: 'success',
        error: '',
        mobile_number: localStorage.getItem('phno')
      })
    } catch (err) {
      console.log("err", err);
      await trackEvent('gender', 'fail', err, localStorage.getItem('phno'))  
      await gTagTracking('gender', {
        action: 'fail',
        error: err,
        mobile_number: localStorage.getItem('phno')
      })
    }
  };

  const handleEvent = async (event) => {
    try{
      await trackEvent(event, 'success', '', localStorage.getItem('phno'))  
      await gTagTracking(event, {
        action: 'success',
        error: '',
        mobile_number: localStorage.getItem('phno')
      })
    } catch(err) {
      console.log("err", err)  
      await trackEvent(event, 'fail', err, localStorage.getItem('phno')) 
      await gTagTracking(event, {
        action: 'fail',
        error: err,
        mobile_number: localStorage.getItem('phno')
      })  
    }  
  }

  const handleDrawer = (which, to) => {
    if (which === "privacy" && to === "open") {
      setPrivacyDrawer(true);
    } else if (which === "privacy" && to === "close") {
      setPrivacyDrawer(false);
    } else if (which === "terms" && to === "open") {
      setTermsDrawer(true);
    } else if (which === "terms" && to === "close") {
      setTermsDrawer(false);
    }
  };

  const capitalizeFirstLetter = (str) => {
    if (typeof str !== 'string' || str.length === 0) {
      return str; // Return as is if not a string or empty
    }
    return str.charAt(0)?.toUpperCase() + str.slice(1);
  }

  const addUser = async () => {
    let userObj = JSON.parse(localStorage.getItem('user_obj'))
    if(!userObj) {
      setIsLoading(true)
      let genderVal = capitalizeFirstLetter(genderToggle)
      let params = {
        year_of_birth: '',
        gender: genderVal,
        first_name: '',
        last_name: '',
        doctor_referral_code: null,
        nurse_referral_code: null,
        clinic_referral_code: null,
        channel: localStorage.getItem('channel')
      }
      console.log("add_patient params", params);
      try {
        let res = await postApi('add_patient', params)
        console.log("add_patient res", res);
        await trackEvent('no_signup_initiated', 'success', " ", localStorage.getItem('phno'), res.user_obj.user_id)
        await gTagTracking('no_signup_initiated', {
          action: 'success',
          error: " ",
          mobile_number: localStorage.getItem('phno'),
          user_id: res.user_obj.user_id,
        })
        setIsLoading(false)
        if(res.error) {
          serviceDown(navigate, localStorage.getItem('channel') === 'alopexia-ads' ? '/c1' : '/start-test')
        } else {
          localStorage.setItem('user_obj', JSON.stringify(res.user_obj))
          navigate("/tutorial", { state: "onboardingComplete" })
        }
      } catch (err) {
        console.log("err", err);
        await trackEvent('no_signup_initiated', 'fail', err, " ", "")
        await gTagTracking('no_signup_initiated', {
          action: 'fail',
          error: err,
          mobile_number: " ",
          user_id: "",
        })
        setIsLoading(false)
      }
    } else {
      navigate("/tutorial", { state: "needhelp" })
    }
  }

  return (
    <>
      {isLoading && <MainLoader/>}
      <div className="onboardingslider">
        <div className="slider-container">
          <Slider
            ref={(slider) => {
              sliderRef = slider;
            }}
            {...settings}
          >
            <div key={1}>
              <div className="sliderone">
                <div className='slideronecontentdiv'>
                  <div className='slideronefirstpara'>
                    <div className='headertxt'>
                      <p>
                        {i18next.t("Please select your gender")}
                      </p>
                    </div>
                    <div className='subtxt'>
                      <p>
                        {i18next.t("This help us improve the accuracy of your analysis")}
                      </p>
                    </div>
                    <div className='genderSelection'>
                      <RadioGroup
                        onChange={(e) => handleToggleChange(e)}
                        value={genderToggle}
                        className='genderTogglegroup'
                      >
                        <FormControlLabel
                          className={genderToggle?.toUpperCase() == "MALE" ? 'maleGenderlabel selected' : 'maleGenderlabel'}
                          key={1}
                          value="male"
                          control={<Radio/>} 
                          label={
                            <div className='genderInfoContainer'>
                              <MaleIcon className='genderIcon'/>
                              <p className={genderToggle?.toUpperCase() == "MALE" ? 'maleGenderText selected' : ''}>{i18next.t("Male")}</p>
                            </div>
                          }
                        />
                        <FormControlLabel
                          className={genderToggle?.toUpperCase() == "FEMALE" ? 'femaleGenderlabel selected' : 'femaleGenderlabel'}
                          key={2}
                          value="female"
                          control={<Radio/>} 
                          label={
                            <div className='genderInfoContainer'>
                              <FemaleIcon className='genderIcon'/>
                              <p className={genderToggle?.toUpperCase() == "FEMALE" ? 'femaleGenderText selected' : ''}>{i18next.t("Female")}</p>
                            </div>
                          }
                        />
                      </RadioGroup>
                    </div>
                    {
                      (genderToggle || !genderToggle == '') &&
                      <div className='subtxtphoto'>
                        <p>{i18next.t(`Take ${genderToggle?.toUpperCase() == "MALE" ? "4" : genderToggle?.toUpperCase() == "FEMALE" ? "2" : "4"} photos of your scalp to create your starting point!`)}</p>
                      </div>
                    }
                  </div>
                  {
                    genderToggle.toUpperCase() == "FEMALE" &&
                      <div className='slideronesecondpara'>
                        <p className='noteHead'>{i18next.t("Important Note")}</p>
                        <p className='noteText'>
                          {i18next.t("All women can take the AI hair loss test. However, the anti-DHT medicines that we recommend are contraindicated for women of reproductive age and is only advised for those who are menopausal.")}
                        </p>
                      </div>
                  }
                </div>
                <div className="slidertext">
                  <Button
                    variant="contained"
                    className={`commonButton mt-20px`}
                    onClick={next}
                  >
                    {i18next.t("Next")}
                  </Button>
                </div>
              </div>
            </div>
            {/* <div key={2}>
              <div className="slidertwo">
                <div className='slideronecontentdiv'>
                  {
                    activeIndex && activeIndex == 1 &&
                    <div className='sliderVideoDiv'> 
                      <ReactPlayer
                        url={
                          genderToggle.toUpperCase() === "MALE" ?
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1763621307/male_photo_qnvu6g.mp4' 
                                :
                            'https://res.cloudinary.com/dgeiynco8/video/upload/v1763621313/femail_photo_ys9pur.mp4'
                        }
                        playing={play}        // Autoplay
                        controls={false}      // Hide controls
                        muted={true}          // Required for autoplay to work in browsers
                        onEnded={() => setPlay(!play)}
                        config={{
                          file: {
                            attributes: {
                              playsInline: true,
                              webkitPlaysInline: true, // for older iOS versions
                            }
                          }
                        }}
                      />
                      <OpenWithIcon 
                        className='expandVideo cursor-pointer' 
                        onClick={() => navigate('/tutorial',{state: {from: 'expandVideo'}})}
                      />
                    </div>
                  }
                  <div className='sliderTwocontent'>
                  <div className='headtext'>
                    <p>{i18next.t("How to Scan Your Hairline Correctly")}</p>
                  </div>
                  <div className='subtext'>
                    <p>{i18next.t("Let’s get ready to take 4 simple photos of your head. Just follow these steps")}</p>
                  </div>
                  <div className='instructionscontainer'>
                    <Box className="guidelines-container">
                      {guidelines && guidelines.map((item, index) => (
                        <Box key={index} className="guideline-item">
                          <Typography variant="h6" className="guideline-title">
                            {index + 1}.
                          </Typography>
                          <Typography
                            variant="body2"
                            className="guideline-description"
                          >
                            {item.description}
                          </Typography>
                        </Box>
                      ))}
                    </Box>
                  </div>
                  </div>
                </div>
                <div className="slidertext">
                  <Button
                    variant="contained"
                    className="commonButton mt-10px"
                    onClick={next}
                  >
                    {i18next.t("Next")}
                  </Button>
                </div>
              </div>
            </div> */}
          </Slider>
          <Drawer
            className="imguplddrwr trmscnddrwr"
            anchor={"bottom"}
            open={open}
            onClose={() => setOpen(false)}
          >
            <div className="drawerhead">
              <p></p>
              <div className="ellipse cursor-pointer" onClick={() => setOpen(false)}>
                <p>X</p>
              </div>
            </div>

            <div className="WordSection1">
              <h1>{i18next.t("Terms of Use")}</h1>

              <p className="MsoNormal">
                {i18next.t("Effective Date: 1 Jan, 2025")}
              </p>

              <h2>{i18next.t("Welcome")}</h2>

              <p className="MsoNormal">
                {i18next.t(
                  "Welcome to the Alopexia website and application! These Terms of Use (“Terms”) govern your use of the services (“Service”) provided by Centa Bio (“us,” “we,” or “our”). By accessing or using the Alopexia website and/or application, you agree to be bound by these Terms."
                )}{" "}
                <br></br>
                <br></br>
              </p>

              <p className="MsoNormal">
                {i18next.t(
                  "If you disagree with any part of these Terms, you may not access the Service."
                )}
              </p>

              <h2>{i18next.t("1. Use of the Service")}</h2>

              <p className="MsoNormal">
                {i18next.t(
                  "Alopexia offers AI-driven personalized haircare solutions, including scalp assessment, treatment recommendations, and progress tracking. The Service is designed to provide actionable insights and personalized treatment options for users experiencing hair loss."
                )}
                <br></br>
                <br></br>
                {i18next.t("By using the Service, you agree to:")}
                <br></br>- {i18next.t("Use the Service only")}
                {i18next.t("for personal, non-commercial purposes.")}
                <br></br>- {i18next.t("Follow all")}
                {i18next.t(
                  "applicable laws and regulations in your use of the Service."
                )}
              </p>

              <h2>{i18next.t("2. Eligibility")}</h2>

              <p className="MsoNormal">
                {i18next.t(
                  "You must be at least 18 years old and a male to use the Service and capable of entering into a lawful agreement. By using the Service, you confirm that you meet these eligibility criteria."
                )}
              </p>

              <h2>{i18next.t("3. Account Creation")}</h2>

              <p className="MsoNormal">
                {i18next.t(
                  "Certain features may require you to create an account. You agree to:"
                )}
                <br></br>-{" "}
                {i18next.t(
                  "Provide accurate and up-to-date information during registration."
                )}
                <br></br>-{" "}
                {i18next.t(
                  "Maintain the confidentiality of your account credentials."
                )}
                <br></br>-{" "}
                {i18next.t(
                  "Notify us immediately of any unauthorized access to your account."
                )}
                <br></br>
                <br></br>
                {i18next.t(
                  "You are solely responsible for activities under your account."
                )}
              </p>

              <h2>{i18next.t("4. Acceptable Use")}</h2>

              <p className="MsoNormal">
                {i18next.t("When using the Service, you agree not to:")}
                <br></br>-{" "}
                {i18next.t(
                  "Interfere with or disrupt the functionality of the Service."
                )}
                <br></br>-{" "}
                {i18next.t(
                  "Use the Service for illegal or unauthorized purposes."
                )}
                <br></br>-{" "}
                {i18next.t(
                  "Upload harmful content, such as viruses, worms, or other malicious software."
                )}
                <br></br>-{" "}
                {i18next.t(
                  "Engage in any activity that compromises the security or integrity of the Service."
                )}
              </p>

              <h2>{i18next.t("5. Intellectual Property Rights")}</h2>

              <p className="MsoNormal">
                {i18next.t(
                  "All content, features, and functionality of the Service are the exclusive property of Centa Bio."
                )}{" "}
                <br></br>
                {i18next.t(
                  "Unauthorized use of trademarks, logos, or proprietary materials is prohibited without prior written consent."
                )}
              </p>

              <h2>{i18next.t("6. Privacy")}</h2>

              <p className="MsoNormal">
                {i18next.t(
                  "Your use of the Service is governed by our Privacy Policy, which outlines how we collect, use, and protect your personal information, including sensitive health data. Please review our Privacy Policy for more details."
                )}
              </p>

              <h2>{i18next.t("7. Data Usage and Sharing")}</h2>

              <p className="MsoNormal">
                {i18next.t("By using the Service, you agree to:")}
                <br></br>-{" "}
                {i18next.t(
                  "Allow Centa Bio to collect and process data, including health-related data, to deliver personalized solutions."
                )}
                <br></br>-{" "}
                {i18next.t(
                  "Consent to data aggregation for research and service improvement."
                )}
                <br></br>-{" "}
                {i18next.t(
                  "Understand that we will not share your personally identifiable information without your explicit consent, except as required by law."
                )}
              </p>

              <h2>{i18next.t("8. Disclaimer of Warranties")}</h2>

              <p className="MsoNormal">
                {i18next.t(
                  "The Service is provided on an “as is” and “as available” basis. Centa Bio does not guarantee uninterrupted access, error-free functionality, or the accuracy of the results generated by the AI-driven assessment."
                )}
              </p>

              <h2>{i18next.t("9. Limitation of Liability")}</h2>

              <p className="MsoNormal">
                {i18next.t(
                  "To the fullest extent permitted by law, Centa Bio shall not be liable for:"
                )}
                <br></br>-{" "}
                {i18next.t("Indirect, incidental, or consequential damages.")}
                <br></br>-{" "}
                {i18next.t(
                  "Loss of data, profits, or goodwill arising from your use of the Service."
                )}
              </p>

              <h2>{i18next.t("10. Changes to the Terms of Use")}</h2>

              <p className="MsoNormal">
                {i18next.t(
                  "We reserve the right to update these Terms at any time. Any changes will be posted on this page, with the updated effective date. Continued use of the Service constitutes acceptance of the revised Terms."
                )}
              </p>

              <h2>{i18next.t("11. Governing Law")}</h2>

              <p className="MsoNormal">
                {i18next.t(
                  "These Terms shall be governed by and construed in accordance with the laws of [Insert Governing Jurisdiction], without regard to its conflict of law principles."
                )}
              </p>

              <h2>{i18next.t("12. Contact Us")}</h2>

              <p className="MsoNormal">
                {i18next.t(
                  "For questions or concerns regarding these Terms, please contact us at:"
                )}
                <br></br>- {i18next.t("Email")}: contact@aloxa.ai
                <br></br>- {i18next.t("Address")}: Centa Biotech SL,Alameda
                Principal 11,9001 Malaga, Spain.
                <br></br>
                {i18next.t(
                  "By accessing or using the Alopexia website and application, you acknowledge that you have read, understood, and agree to these Terms of Use."
                )}
              </p>
            </div>
          </Drawer>
        </div>
        <AlertComp open={alertopen} msg={alertmsg} type={"error"} />
        <Drawer
          className="privacypolicydrawer"
          anchor={"bottom"}
          open={privacyDrawer}
          onClose={() => handleDrawer("privacy", "close")}
        >
          <div className="drawerhead">
            <div
              className="ellipse cursor-pointer"
              onClick={() => handleDrawer("privacy", "close")}
            >
              <p>X</p>
            </div>
          </div>
          <HtmlContentMaster keyName={"privacypolicy"} />
        </Drawer>
      </div>
    </>
  );
}

export default OnBoardingSlider